import { Pipe, PipeTransform } from '@angular/core';
import {  TIC_SPECIALTY_CATEGORY } from '@app/config/tic-name.enum';

@Pipe({
  name: 'ticName'
})
export class TicSpecialtyNamePipe implements PipeTransform {

  transform(value: any): string {

    return TIC_SPECIALTY_CATEGORY[TIC_SPECIALTY_CATEGORY.findIndex(x => x.id === value)].name || ''
  }

}
